<template>
  <div class="wrap">
    <relationModel v-if="relationModelStatus" @closerelationModel="closerelationModel"/>
    <div class="header_wrap">
      <div class="header">
        <div class="header_left">
          <img src="../../static/images/logo.png" alt="">
        </div>
        <div class="header_right">
          <ul class="navigate">
            <li>
              <div :class="liboxbgshow == '首页'? 'libox liboxbg' :'libox' ">
                <p class="navName" @click="toHome">首页</p>
              </div>
            </li>
            <li>
              <div  :class="liboxbgshow == '解决方案'? 'libox liboxbg' :'libox' ">
                <p class="navName" @click="solve">解决方案</p>
                <div class="navBox jjfa" v-if="false">
                  <div class="solve">
                    <ul class="solve_list solve_r">
                      <li>
                        <p class="tittle">油品行业解决方案</p>
                        <p class="line"></p>
                      </li>
                      <li>油品·采购与分销</li>
                      <li>油品·零售管理</li>
                      <li>油品·CRM与营销</li>
                      <li>油品·支付与对账</li>
                      <li>油品·一键加油</li>
                      <li>油品·站级系统</li>
                    </ul>
                    <ul class="solve_list solve_r">
                      <li>
                        <p class="tittle">零售行业解决方案</p>
                        <p class="line"></p>
                      </li>
                      <li>零售·便利店云管家</li>
                      <li>零售·微商城</li>
                      <li>零售·无人值守便利店</li>
                      <li>零售·扫码购</li>
                      <li>零售·门店管家App</li>
                      <li>零售·督导巡店App</li>
                    </ul>
                    <ul class="solve_list">
                      <li>
                        <p class="tittle">智慧终端解决方案</p>
                        <p class="line"></p>
                      </li>
                      <li>双屏收银终端</li>
                      <li>自助收银终端</li>
                      <li>手持收银终端</li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div :class="liboxbgshow == '商务合作'? 'libox liboxbg' :'libox' ">
                <p class="navName" @click="teamwork">商务合作</p>
              </div>
            </li>
            <li>
              <div :class="liboxbgshow == '联系我们'? 'libox liboxbg' :'libox' ">
                <p class="navName" @click="torelation">联系我们</p>
              </div>
            </li>
            <!-- <li>
              <div class="libox">
                <p class="navName">登录</p>
                <div class="navBox dl">
                  <p class="loginto">督导巡店入口</p>
                  <p class="loginto">油品客户入口</p>
                </div>
              </div>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="banner" v-if="!relationModelStatus">
      <el-carousel>
        <el-carousel-item>
          <img src="../../static/images/banner01.png">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="content_wrap" v-if="!relationModelStatus">
      <div class="content">
        <p class="tittle">油品行业解决方案</p>
        <p class="explain">为中大型石油石化企业和民营加油站提供专业解决方案</p>
        <ul class="list">
          <li v-for="(item,index) in content" :key="index">
            <img class="list_img" :src="item.img" alt="">
            <p class="list_tittle">{{item.tittle}}</p>
            <p class="list_explain">{{item.explain}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="bav_wrap" v-if="!relationModelStatus">
      <div class="bav">
        <p class="tittle">零售行业解决方案</p>
        <p class="explain">助力商家转型，形成新一代互联网全渠道零售模式</p>
        <ul class="list">
          <li @click="bav(index)" v-for="(item,index) in list" :key="index">
            <img class="bav_img" v-if="listindex == index? false:true" :src="item.bav_img" alt="">
            <img class="bav_img" v-else :src="item.bgimg" alt="">
            <p :class="listindex == index? 'name namebg':'name' ">{{item.name}}</p>
            <span :class="listindex == index? 'line linebg':'line' "></span>
          </li>
        </ul>
        <div class="details_box" v-show="listindex == index" v-for="(item,index) in list" :key="index">
          <div class="details_left">
            <div class="summarize">{{item.summarize}}</div>
            <div class="more">了解更多</div>
          </div>
          <div class="details_right">
            <img :src="item.detailsimg" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!relationModelStatus">
      <div class="foot">
        <img src="../../static/images/card.png" alt="" class="card">
        <div class="connection">
          <p class="connec">联系我们：林经理 linxuan@ecareyun.com</p>
          <p class="connec">北京云赋网络科技有限公司</p>
          <p class="connec connecbg">
            <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/recordQuery">京ICP备17022349号-1</a>
            <a class="conneca" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502044345">
              <img src="../../static/images/ba.png" alt="">
              <p>京公网安备 11010502044345号</p>
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import relationModel from '@/components/relationModel';
export default {
  name: 'Home',
  components:{relationModel},
  data () {
    return {
      liboxbgshow:'首页',
      relationModelStatus:false,
      nav:[
        {
          'name':'首页',
        },
        {
          'name':'解决方案',
        },
        {
          'name':'商务合作',
        },
        {
          'name':'联系我们',
        },
        {
          'name':'登录',
        },
      ],
      list:[
        {
          'bav_img':'../../static/images/bav1.png',
          'bgimg':'../../static/images/bav01.png',
          'detailsimg':'../../static/images/detailsimg1.png',
          'name':'便利店云管家',
          'summarize':'解决便利店采购、验收、营销、商品库存、成本核算等便利店的核心进销存管理功能'
        },
        {
          'bav_img':'../../static/images/bav2.png',
          'bgimg':'../../static/images/bav02.png',
          'detailsimg':'../../static/images/detailsimg2.png',
          'name':'微商城',
          'summarize':'微信公众号、小程序、APP等渠道入口 为商家提供线上销售渠道，支持多商户入驻，可提供配送到家及门店自提等业务模式'
        },
        {
          'bav_img':'../../static/images/bav3.png',
          'bgimg':'../../static/images/bav03.png',
          'detailsimg':'../../static/images/detailsimg3.png',
          'name':'扫码购',
          'summarize':'支持Android版和IOS版，H5嵌入方式 可接入小程序、公众号及APP，并结合个性化优惠券及购物车等促销运营模式，提高客单价、增加订单量。简单高效的移动销售工具，为门店补充销售渠道，避免顾客高峰期排队的苦恼。 商家的优惠信息、促销活动、会员资讯等服务，也能通过“扫码购”高效、直接地触达顾客。'
        },
        {
          'bav_img':'../../static/images/bav4.png',
          'bgimg':'../../static/images/bav04.png',
          'detailsimg':'../../static/images/detailsimg4.png',
          'name':'门店管家App',
          'summarize':'以微信小程序形式轻量化运行，易扩展易维护，实现便利业务的移动化、轻便化。 线上线下完全打通，真正实现了便利店线下日常业务与线上业务的深度融合。 管理部门可对便利店相应业务进行跟踪，通过消息通知服务，实时掌握各项任务的进度。'
        },
        {
          'bav_img':'../../static/images/bav5.png',
          'bgimg':'../../static/images/bav05.png',
          'detailsimg':'../../static/images/detailsimg5.png',
          'name':'督导巡店App',
          'summarize':'实现企业各级管理部门、督导员和门店的联动机制，实现标准化与自定义的巡店模板，也可下发督导巡店任务和门店自检任务，实现门店状态信息上报，实现考评打分与整改任务信息下发。也可实现门店价格、营销、库存、盘点等数据督导工作。'
        }
      ],
      listindex:0,
      content:[
        {
          'img':'../../static/images/list_001.png',
          'tittle':'油品·采购与分销',
          'explain':'基于成品油采购、 批发、直销、客户、信用、结算的一体化解决方案'
        },
        {
          'img':'../../static/images/list_002.png',
          'tittle':'油品·零售与管理',
          'explain':'包括价格管理、定点客户管理、 油站账表管理、资金管理， 可以查看油站的每笔销售和报表'
        },
        {
          'img':'../../static/images/list_003.png',
          'tittle':'油品·CRM与营销',
          'explain':'管理客户信息支持线上线下多种渠道提供多样化营销功能'
        },
        {
          'img':'../../static/images/list_004.png',
          'tittle':'油品·支付与对账',
          'explain':'支持微信、支付宝等多种支付方式，支持单品营销， 实现业务和支付的账务核对'
        },
        {
          'img':'../../static/images/list_005.png',
          'tittle':'油品·移动加油',
          'explain':'通过移动端，为客户提供油站导航， 实现客户自助加油与支付的业务场景'
        },
        {
          'img':'../../static/images/list_006.png',
          'tittle':'油品·站级系统',
          'explain':'包括管控系统、前台收银系统，支持手持和大屏自助设备，实现油品和非油品的销售管理，支持油非一体收银'
        }
      ],
    }
  },
  methods: {
    bav (n){
      this.listindex = n
    },
    closerelationModel () {
      this.relationModelStatus = false;
    },
    //首页
    toHome () {
      this.liboxbgshow = '首页'
      this.relationModelStatus = false;
    },
    //商务合作
    teamwork () {
      this.liboxbgshow = '商务合作'
    },
    //解决方案
    solve () {
      this.liboxbgshow = '解决方案'
    },
    //联系我们
    torelation () {
      this.liboxbgshow = '联系我们'
      this.relationModelStatus = true;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../assets/css/style.scss';
</style>



// WEBPACK FOOTER //
// src/components/Home.vue